import i18next from 'i18next';

export const isRtl = () => {
  const language = i18next.language;
  return i18next.options.rtl.includes(language);
};
